import { useThemeStore } from 'src/stores/ThemeStore';
import NoDocumentsIcon from 'src/assets/icons/no-documents-found.svg';
import NoDocumentsDeloitteIcon from 'src/assets/icons/deloitte/no-documents-found.svg';
import styles from './NoDocumentsFound.module.scss';

export const NoDocumentsFound = () => {
  const { isDeloitteTheme } = useThemeStore();

  return (
    <div className={styles['no-docs-found-container']}>
      <img src={isDeloitteTheme ? NoDocumentsDeloitteIcon : NoDocumentsIcon} alt="No documents found" />
      <p>No Documents Found</p>
    </div>
  );
};
